export const formConfig = {
  "access": {
    "hub": {
      "enabled": true,
      "path": "/hub",
      "accessKeyEnvVar": "VITE_HUB_ACCESS_KEY"
    },
    "publicShare": {
      "enabled": true,
      "queryParam": "k"
    }
  },
  "app": {
    "name": "BPA Forms Hub",
    "description": "A premium, configurable multi form intake hub for BPA Solutions, with consistent theming, navigation, routing, and automated email workflows.",
    "version": "1.0.0",
    "branding": {
      "logo": "https://i.ibb.co/QjnJygFC/logo.webp",
      "primaryColorRef": "primary",
      "accentColorRef": "accent"
    },
    "layout": {
      "sidebar": {
        "enabled": true,
        "position": "left",
        "width": "280px"
      },
      "header": {
        "enabled": true,
        "showLogo": true,
        "showAppName": true
      }
    },
    "defaultTheme": "light"
  },
  "themes": {
    "themes": [
      {
        "id": "light",
        "label": "Light",
        "isDark": false,
        "colors": {
          "background": "#ffffff",
          "surface": "#f8fafc",
          "surfaceAlt": "#f1f5f9",
          "primary": "#1d4ed8",
          "primarySoft": "#dbeafe",
          "primaryStrong": "#1e40af",
          "accent": "#0ea5e9",
          "accentSoft": "#e0f2fe",
          "accentStrong": "#0369a1",
          "border": "#e2e8f0",
          "text": "#0f172a",
          "textMuted": "#475569",
          "success": "#16a34a",
          "warning": "#f59e0b",
          "danger": "#dc2626"
        },
        "components": {
          "button": {
            "borderRadius": "12px",
            "paddingX": "16px",
            "paddingY": "12px",
            "fontWeight": "700"
          },
          "input": {
            "borderRadius": "12px",
            "paddingX": "14px",
            "paddingY": "12px",
            "borderColor": "#e2e8f0",
            "focusBorderColor": "#1d4ed8"
          },
          "card": {
            "borderRadius": "16px",
            "padding": "24px",
            "elevation": "sm"
          }
        }
      },
      {
        "id": "dark",
        "label": "Dark",
        "isDark": true,
        "colors": {
          "background": "#0b1220",
          "surface": "#0f172a",
          "surfaceAlt": "#111c33",
          "primary": "#60a5fa",
          "primarySoft": "#172554",
          "primaryStrong": "#93c5fd",
          "accent": "#22d3ee",
          "accentSoft": "#164e63",
          "accentStrong": "#67e8f9",
          "border": "#23314f",
          "text": "#e5e7eb",
          "textMuted": "#9ca3af",
          "success": "#22c55e",
          "warning": "#fbbf24",
          "danger": "#f87171"
        },
        "components": {
          "button": {
            "borderRadius": "12px",
            "paddingX": "16px",
            "paddingY": "12px",
            "fontWeight": "700"
          },
          "input": {
            "borderRadius": "12px",
            "paddingX": "14px",
            "paddingY": "12px",
            "borderColor": "#23314f",
            "focusBorderColor": "#60a5fa"
          },
          "card": {
            "borderRadius": "16px",
            "padding": "24px",
            "elevation": "sm"
          }
        }
      }
    ],
    "themeSwitcher": {
      "enabled": true,
      "position": "header-right"
    }
  },
  "navigation": {
    "primary": {
      "items": [
        {
          "id": "navWebsiteIntake",
          "label": "Website Client Intake",
          "icon": "Clipboard",
          "type": "form",
          "targetId": "websiteClientIntake"
        },
        {
          "id": "navAdsIntake",
          "label": "Ads Intake",
          "icon": "Target",
          "type": "form",
          "targetId": "adsIntake"
        },
        {
          "id": "navUpdateRequest",
          "label": "Update Request",
          "icon": "Edit3",
          "type": "form",
          "targetId": "updateRequest"
        }
      ]
    },
    "secondary": {
      "items": [
        {
          "id": "navResearchNotes",
          "label": "Research Notes",
          "icon": "FileText",
          "type": "page",
          "targetId": "researchNotes"
        }
      ]
    },
    "footer": {
      "items": [
        {
          "id": "navPrivacy",
          "label": "Privacy Policy",
          "icon": "Shield",
          "type": "page",
          "targetId": "privacyPolicy"
        },
        {
          "id": "navTerms",
          "label": "Terms",
          "icon": "File",
          "type": "page",
          "targetId": "terms"
        }
      ]
    }
  },
  "site": {
    "baseUrl": "https://forms.bpasolutions.au",
    "publicBaseUrl": "https://forms.bpasolutions.au",
    "pages": [
      {
        "id": "researchNotes",
        "title": "Research Notes",
        "blocks": [
          {
            "type": "paragraph",
            "text": "This page is reserved for internal knowledge management about the BPA Forms Hub configuration."
          },
          {
            "type": "bullets",
            "items": [
              "This configuration is designed to be extended with more forms.",
              "It supersedes an older schema (meta,site,forms,email_logic) by introducing app,themes,navigation,site,forms,email,and research while preserving intent."
            ]
          }
        ]
      },
      {
        "id": "privacyPolicy",
        "title": "Privacy Policy",
        "blocks": [
          {
            "type": "paragraph",
            "text": "Placeholder privacy policy page. Replace with your final policy content before production use."
          }
        ]
      },
      {
        "id": "terms",
        "title": "Terms",
        "blocks": [
          {
            "type": "paragraph",
            "text": "Placeholder terms page. Replace with your final terms content before production use."
          }
        ]
      }
    ],
    "routes": [
      {
        "id": "routeWebsiteClientIntake",
        "path": "/website-intake",
        "sharePath": "/f/website-intake",
        "shareKey": "WINTAKE-2026",
        "label": "Website Client Intake",
        "description": "Full intake form for premium website projects.",
        "type": "form",
        "targetId": "websiteClientIntake",
        "icon": "Clipboard",
        "visibleInNav": true
      },
      {
        "id": "routeAdsIntake",
        "path": "/ads-intake",
        "sharePath": "/f/ads-intake",
        "shareKey": "ADS-2026",
        "label": "Ads Intake",
        "description": "Initial intake for paid media campaigns.",
        "type": "form",
        "targetId": "adsIntake",
        "icon": "Target",
        "visibleInNav": true
      },
      {
        "id": "routeUpdateRequest",
        "path": "/update-request",
        "sharePath": "/f/update-request",
        "shareKey": "UPDATE-2026",
        "label": "Update Request",
        "description": "Submit a change request for an existing site or asset.",
        "type": "form",
        "targetId": "updateRequest",
        "icon": "Edit3",
        "visibleInNav": true
      },
      {
        "id": "routeResearchNotes",
        "path": "/research-notes",
        "label": "Research Notes",
        "description": "Internal notes and configuration guidance.",
        "type": "page",
        "targetId": "researchNotes",
        "icon": "FileText",
        "visibleInNav": false
      },
      {
        "id": "routePrivacy",
        "path": "/privacy",
        "label": "Privacy Policy",
        "description": "Privacy policy content page.",
        "type": "page",
        "targetId": "privacyPolicy",
        "icon": "Shield",
        "visibleInNav": false
      },
      {
        "id": "routeTerms",
        "path": "/terms",
        "label": "Terms",
        "description": "Terms and conditions content page.",
        "type": "page",
        "targetId": "terms",
        "icon": "File",
        "visibleInNav": false
      }
    ]
  },
  "forms": [
    {
      "id": "websiteClientIntake",
      "name": "Website Client Intake",
      "description": "A premium end to end intake for high end website projects, covering scope, design, SEO, compliance, and delivery constraints.",
      "category": "Client Onboarding",
      "icon": "Clipboard",
      "layout": {
        "columns": 1,
        "showSectionProgress": true,
        "showOverallProgress": true,
        "progressStyle": "steps"
      },
      "submission": {
        "successMessage": "Thank you. Your website intake has been submitted successfully. Our team will review it and contact you shortly.",
        "failureMessage": "Submission failed. Please check the form and try again, or contact support.",
        "redirectUrl": null,
        "storeSubmission": true
      },
      "fields": [
        {
          "id": "clientName",
          "type": "text",
          "label": "Client name",
          "placeholder": "Full name",
          "helperText": "Primary contact for this project.",
          "required": true,
          "defaultValue": null
        },
        {
          "id": "clientEmail",
          "type": "email",
          "label": "Email",
          "placeholder": "name@business.com",
          "helperText": "We will send a confirmation to this address.",
          "required": true,
          "defaultValue": null
        },
        {
          "id": "clientPhone",
          "type": "tel",
          "label": "Phone number",
          "placeholder": "Mobile or direct line",
          "helperText": "Used for urgent questions and launch coordination.",
          "required": true,
          "defaultValue": null
        },
        {
          "id": "businessName",
          "type": "text",
          "label": "Company name",
          "placeholder": "Business or trading name",
          "helperText": null,
          "required": true,
          "defaultValue": null
        },
        {
          "id": "businessAbn",
          "type": "text",
          "label": "ABN (optional)",
          "placeholder": "Australian Business Number",
          "helperText": null,
          "required": false,
          "defaultValue": null
        },
        {
          "id": "businessAddress",
          "type": "textarea",
          "label": "Business address (optional)",
          "placeholder": "Street, suburb, state, postcode",
          "helperText": null,
          "required": false,
          "defaultValue": null
        },
        {
          "id": "industry",
          "type": "text",
          "label": "Industry",
          "placeholder": "For example: plumbing, legal, NDIS, clinic",
          "helperText": null,
          "required": true,
          "defaultValue": null
        },
        {
          "id": "businessOverview",
          "type": "textarea",
          "label": "Business overview",
          "placeholder": "Describe what you do, who you serve, and what makes you different.",
          "helperText": "This helps us write strong messaging and structure the page flow.",
          "required": true,
          "defaultValue": null
        },
        {
          "id": "targetAudience",
          "type": "textarea",
          "label": "Target audience",
          "placeholder": "Who are your ideal customers and what do they care about?",
          "helperText": null,
          "required": true,
          "defaultValue": null
        },
        {
          "id": "primaryGoal",
          "type": "select",
          "label": "Primary project goal",
          "placeholder": null,
          "helperText": "Choose the main outcome you want from the website.",
          "required": true,
          "defaultValue": null,
          "options": [
            {
              "value": "lead-gen",
              "label": "Generate more enquiries"
            },
            {
              "value": "credibility",
              "label": "Improve trust and credibility"
            },
            {
              "value": "sales",
              "label": "Sell products or services online"
            },
            {
              "value": "automation",
              "label": "Reduce admin with automation"
            },
            {
              "value": "other",
              "label": "Other"
            }
          ]
        },
        {
          "id": "successMetrics",
          "type": "textarea",
          "label": "Success metrics",
          "placeholder": "For example: 30 qualified enquiries per month, 2 percent conversion rate, reduced calls",
          "helperText": "Define how you will measure success after launch.",
          "required": true,
          "defaultValue": null
        },
        {
          "id": "currentWebsite",
          "type": "url",
          "label": "Current website (if any)",
          "placeholder": "https://",
          "helperText": null,
          "required": false,
          "defaultValue": null
        },
        {
          "id": "brandAssetsReady",
          "type": "select",
          "label": "Brand assets readiness",
          "placeholder": null,
          "helperText": "Do you have a logo and brand guidelines ready?",
          "required": true,
          "defaultValue": null,
          "options": [
            {
              "value": "ready",
              "label": "Yes, everything is ready"
            },
            {
              "value": "partial",
              "label": "Some assets exist but need improvement"
            },
            {
              "value": "none",
              "label": "No, we need help creating them"
            }
          ]
        },
        {
          "id": "marketingChannels",
          "type": "multiselect",
          "label": "Marketing channels you use or plan to use",
          "placeholder": null,
          "helperText": "Select all that apply.",
          "required": true,
          "defaultValue": null,
          "options": [
            {
              "value": "seo",
              "label": "SEO"
            },
            {
              "value": "google-ads",
              "label": "Google Ads"
            },
            {
              "value": "meta-ads",
              "label": "Facebook and Instagram Ads"
            },
            {
              "value": "social",
              "label": "Social media content"
            },
            {
              "value": "email",
              "label": "Email marketing"
            },
            {
              "value": "referrals",
              "label": "Referrals"
            },
            {
              "value": "offline",
              "label": "Offline marketing"
            }
          ]
        },
        {
          "id": "designStyle",
          "type": "select",
          "label": "Preferred style",
          "placeholder": null,
          "helperText": "Choose the feel you want visitors to experience.",
          "required": true,
          "defaultValue": null,
          "options": [
            {
              "value": "modern-minimal",
              "label": "Modern and minimal"
            },
            {
              "value": "bold-premium",
              "label": "Bold and premium"
            },
            {
              "value": "friendly-warm",
              "label": "Friendly and warm"
            },
            {
              "value": "clinical-clean",
              "label": "Clean and clinical"
            },
            {
              "value": "heritage-trust",
              "label": "Traditional and trust focused"
            }
          ]
        },
        {
          "id": "toneOfVoice",
          "type": "select",
          "label": "Tone of voice",
          "placeholder": null,
          "helperText": null,
          "required": true,
          "defaultValue": null,
          "options": [
            {
              "value": "direct",
              "label": "Direct and confident"
            },
            {
              "value": "professional",
              "label": "Professional and formal"
            },
            {
              "value": "friendly",
              "label": "Friendly and approachable"
            },
            {
              "value": "luxury",
              "label": "Luxury and aspirational"
            }
          ]
        },
        {
          "id": "exampleWebsites",
          "type": "textarea",
          "label": "Example websites you like",
          "placeholder": "Paste URLs and explain what you like about each",
          "helperText": "This helps align visual direction quickly.",
          "required": false,
          "defaultValue": null
        },
        {
          "id": "brandColours",
          "type": "textarea",
          "label": "Brand colours (optional)",
          "placeholder": "List hex codes or describe preferred colours",
          "helperText": null,
          "required": false,
          "defaultValue": null
        },
        {
          "id": "requiredPages",
          "type": "multiselect",
          "label": "Pages required",
          "placeholder": null,
          "helperText": "Select all pages you want included.",
          "required": true,
          "defaultValue": null,
          "options": [
            {
              "value": "home",
              "label": "Home"
            },
            {
              "value": "about",
              "label": "About"
            },
            {
              "value": "services",
              "label": "Services"
            },
            {
              "value": "service-detail",
              "label": "Service detail pages"
            },
            {
              "value": "gallery",
              "label": "Gallery"
            },
            {
              "value": "reviews",
              "label": "Reviews"
            },
            {
              "value": "pricing",
              "label": "Pricing"
            },
            {
              "value": "faq",
              "label": "FAQ"
            },
            {
              "value": "blog",
              "label": "Blog"
            },
            {
              "value": "contact",
              "label": "Contact"
            }
          ]
        },
        {
          "id": "contentReadiness",
          "type": "select",
          "label": "Content readiness",
          "placeholder": null,
          "helperText": "How ready is your copy and media content?",
          "required": true,
          "defaultValue": null,
          "options": [
            {
              "value": "ready",
              "label": "Ready to provide all copy and assets"
            },
            {
              "value": "partial",
              "label": "Some content exists but needs editing"
            },
            {
              "value": "need-copywriting",
              "label": "Need copywriting support"
            }
          ]
        },
        {
          "id": "siteFeatures",
          "type": "multiselect",
          "label": "Desired site features",
          "placeholder": null,
          "helperText": "Select all that apply.",
          "required": true,
          "defaultValue": null,
          "options": [
            {
              "value": "lead-forms",
              "label": "Enquiry forms"
            },
            {
              "value": "booking",
              "label": "Online booking"
            },
            {
              "value": "payments",
              "label": "Payments"
            },
            {
              "value": "ecommerce",
              "label": "E-commerce"
            },
            {
              "value": "memberships",
              "label": "Membership or portal"
            },
            {
              "value": "chat",
              "label": "Chat widget"
            },
            {
              "value": "crm",
              "label": "CRM integration"
            },
            {
              "value": "automation",
              "label": "Automation workflows"
            },
            {
              "value": "multilingual",
              "label": "Multilingual"
            },
            {
              "value": "blog",
              "label": "Blog"
            },
            {
              "value": "reviews",
              "label": "Reviews integration"
            }
          ]
        },
        {
          "id": "integrations",
          "type": "textarea",
          "label": "Integrations (optional)",
          "placeholder": "List any tools you use: CRM, booking system, email platform, payment provider",
          "helperText": null,
          "required": false,
          "defaultValue": null
        },
        {
          "id": "seoLocations",
          "type": "textarea",
          "label": "Service locations for SEO",
          "placeholder": "List suburbs, regions, or cities you want to rank for",
          "helperText": "Be as specific as possible.",
          "required": true,
          "defaultValue": null
        },
        {
          "id": "seoKeywords",
          "type": "textarea",
          "label": "Target keywords",
          "placeholder": "List your main search phrases",
          "helperText": "Example: emergency plumber northern beaches",
          "required": true,
          "defaultValue": null
        },
        {
          "id": "competitors",
          "type": "textarea",
          "label": "Competitors (optional)",
          "placeholder": "List competitor websites or business names",
          "helperText": null,
          "required": false,
          "defaultValue": null
        },
        {
          "id": "privacyPolicyStatus",
          "type": "select",
          "label": "Privacy policy status",
          "placeholder": null,
          "helperText": "Do you already have a policy?",
          "required": true,
          "defaultValue": null,
          "options": [
            {
              "value": "have",
              "label": "Yes, we have one"
            },
            {
              "value": "need",
              "label": "No, we need one created"
            },
            {
              "value": "update",
              "label": "We have one but it needs updating"
            }
          ]
        },
        {
          "id": "termsStatus",
          "type": "select",
          "label": "Terms and conditions status",
          "placeholder": null,
          "helperText": null,
          "required": true,
          "defaultValue": null,
          "options": [
            {
              "value": "have",
              "label": "Yes, we have them"
            },
            {
              "value": "need",
              "label": "No, we need them created"
            },
            {
              "value": "update",
              "label": "We have them but they need updating"
            }
          ]
        },
        {
          "id": "cookieConsent",
          "type": "toggle",
          "label": "Cookie consent banner required",
          "placeholder": null,
          "helperText": "Enable if you track analytics or ads.",
          "required": false,
          "defaultValue": false
        },
        {
          "id": "accessibilityTarget",
          "type": "select",
          "label": "Accessibility target (optional)",
          "placeholder": null,
          "helperText": null,
          "required": false,
          "defaultValue": null,
          "options": [
            {
              "value": "wcag-aa",
              "label": "WCAG 2.1 AA"
            },
            {
              "value": "basic",
              "label": "Basic best practice"
            }
          ]
        },
        {
          "id": "analytics",
          "type": "multiselect",
          "label": "Analytics and tracking",
          "placeholder": null,
          "helperText": "Select what you need.",
          "required": false,
          "defaultValue": null,
          "options": [
            {
              "value": "ga4",
              "label": "Google Analytics 4"
            },
            {
              "value": "gsc",
              "label": "Google Search Console"
            },
            {
              "value": "gtm",
              "label": "Google Tag Manager"
            },
            {
              "value": "meta-pixel",
              "label": "Meta Pixel"
            },
            {
              "value": "call-tracking",
              "label": "Call tracking"
            }
          ]
        },
        {
          "id": "hostingPreference",
          "type": "select",
          "label": "Hosting preference",
          "placeholder": null,
          "helperText": null,
          "required": true,
          "defaultValue": null,
          "options": [
            {
              "value": "bpa",
              "label": "BPA managed hosting"
            },
            {
              "value": "client",
              "label": "Client managed hosting"
            },
            {
              "value": "unsure",
              "label": "Not sure"
            }
          ]
        },
        {
          "id": "budgetRange",
          "type": "select",
          "label": "Project budget range",
          "placeholder": null,
          "helperText": "Select the range that best fits your expectations.",
          "required": true,
          "defaultValue": null,
          "options": [
            {
              "value": "2k-5k",
              "label": "$2k to $5k"
            },
            {
              "value": "5k-10k",
              "label": "$5k to $10k"
            },
            {
              "value": "10k-20k",
              "label": "$10k to $20k"
            },
            {
              "value": "20k-plus",
              "label": "$20k+"
            }
          ]
        },
        {
          "id": "timelineUrgency",
          "type": "select",
          "label": "Timeline urgency",
          "placeholder": null,
          "helperText": null,
          "required": true,
          "defaultValue": null,
          "options": [
            {
              "value": "asap",
              "label": "ASAP"
            },
            {
              "value": "1-3",
              "label": "1 to 3 months"
            },
            {
              "value": "3-6",
              "label": "3 to 6 months"
            },
            {
              "value": "6-plus",
              "label": "6+ months"
            }
          ]
        },
        {
          "id": "targetLaunchDate",
          "type": "date",
          "label": "Target launch date",
          "placeholder": null,
          "helperText": "If you have a specific date, enter it here.",
          "required": true,
          "defaultValue": null
        },
        {
          "id": "constraints",
          "type": "textarea",
          "label": "Key constraints",
          "placeholder": "Any deadlines, approvals, compliance requirements, or dependencies",
          "helperText": null,
          "required": false,
          "defaultValue": null
        },
        {
          "id": "stakeholders",
          "type": "textarea",
          "label": "Stakeholders and decision makers",
          "placeholder": "Who is involved and who signs off?",
          "helperText": null,
          "required": true,
          "defaultValue": null
        },
        {
          "id": "communicationPreference",
          "type": "select",
          "label": "Communication preference",
          "placeholder": null,
          "helperText": null,
          "required": true,
          "defaultValue": null,
          "options": [
            {
              "value": "email",
              "label": "Email"
            },
            {
              "value": "phone",
              "label": "Phone call"
            },
            {
              "value": "whatsapp",
              "label": "WhatsApp"
            },
            {
              "value": "meet",
              "label": "Video meeting"
            }
          ]
        },
        {
          "id": "fileUploads",
          "type": "file",
          "label": "Upload files (optional)",
          "placeholder": null,
          "helperText": "Logos, brand guides, copy docs, images, or anything helpful.",
          "required": false,
          "defaultValue": null
        },
        {
          "id": "additionalNotes",
          "type": "textarea",
          "label": "Additional notes",
          "placeholder": "Anything else we should know",
          "helperText": null,
          "required": false,
          "defaultValue": null
        },
        {
          "id": "marketingOptIn",
          "type": "checkbox",
          "label": "I would like to receive helpful updates and insights (optional)",
          "placeholder": null,
          "helperText": null,
          "required": false,
          "defaultValue": false
        },
        {
          "id": "consentAcknowledgement",
          "type": "checkbox",
          "label": "I acknowledge the Privacy Policy and Terms and confirm the information provided is accurate",
          "placeholder": null,
          "helperText": "Required to submit this form.",
          "required": true,
          "defaultValue": false
        }
      ],
      "sections": [
        {
          "id": "clientDetails",
          "title": "Client details",
          "description": "Basic contact and company information.",
          "fieldIds": [
            "clientName",
            "clientEmail",
            "clientPhone",
            "businessName",
            "businessAbn",
            "businessAddress",
            "industry"
          ]
        },
        {
          "id": "projectOverview",
          "title": "Project overview",
          "description": "Goals, positioning, and success metrics.",
          "fieldIds": [
            "businessOverview",
            "targetAudience",
            "primaryGoal",
            "successMetrics"
          ]
        },
        {
          "id": "currentPresence",
          "title": "Current presence",
          "description": "Existing website and marketing footprint.",
          "fieldIds": [
            "currentWebsite",
            "marketingChannels"
          ]
        },
        {
          "id": "designPreferences",
          "title": "Design preferences",
          "description": "Style direction and inspiration.",
          "fieldIds": [
            "brandAssetsReady",
            "designStyle",
            "toneOfVoice",
            "exampleWebsites",
            "brandColours"
          ]
        },
        {
          "id": "siteStructureAndContent",
          "title": "Site structure and content",
          "description": "Pages and content readiness.",
          "fieldIds": [
            "requiredPages",
            "contentReadiness"
          ]
        },
        {
          "id": "functionalRequirements",
          "title": "Functional requirements",
          "description": "Features and integrations.",
          "fieldIds": [
            "siteFeatures",
            "integrations"
          ]
        },
        {
          "id": "seoAndDiscovery",
          "title": "SEO and discovery",
          "description": "Keywords, locations, and competitors.",
          "fieldIds": [
            "seoLocations",
            "seoKeywords",
            "competitors"
          ]
        },
        {
          "id": "legalAndCompliance",
          "title": "Legal and compliance",
          "description": "Policies, consent, and accessibility.",
          "fieldIds": [
            "privacyPolicyStatus",
            "termsStatus",
            "cookieConsent",
            "accessibilityTarget"
          ]
        },
        {
          "id": "technicalAndAutomation",
          "title": "Technical and automation",
          "description": "Hosting and tracking requirements.",
          "fieldIds": [
            "hostingPreference",
            "analytics"
          ]
        },
        {
          "id": "contentAndAssets",
          "title": "Content and assets",
          "description": "Uploads and assets provided.",
          "fieldIds": [
            "fileUploads"
          ]
        },
        {
          "id": "budgetAndTimeline",
          "title": "Budget and timeline",
          "description": "Budget range and delivery timing.",
          "fieldIds": [
            "budgetRange",
            "timelineUrgency",
            "targetLaunchDate",
            "constraints"
          ]
        },
        {
          "id": "decisionMaking",
          "title": "Decision making",
          "description": "Approvals and communication.",
          "fieldIds": [
            "stakeholders",
            "communicationPreference"
          ]
        },
        {
          "id": "additionalNotesSection",
          "title": "Additional notes",
          "description": "Anything else we should consider.",
          "fieldIds": [
            "additionalNotes"
          ]
        },
        {
          "id": "consent",
          "title": "Consent",
          "description": "Confirm consent and optional marketing opt in.",
          "fieldIds": [
            "marketingOptIn",
            "consentAcknowledgement"
          ]
        }
      ]
    },
    {
      "id": "adsIntake",
      "name": "Ads Intake",
      "description": "Initial intake for paid advertising campaigns across Google and social platforms.",
      "category": "Campaigns",
      "icon": "Target",
      "layout": {
        "columns": 1,
        "showSectionProgress": true,
        "showOverallProgress": false,
        "progressStyle": "steps"
      },
      "submission": {
        "successMessage": "Thank you. Your ads intake has been submitted successfully.",
        "failureMessage": "Submission failed. Please try again.",
        "redirectUrl": null,
        "storeSubmission": true
      },
      "fields": [
        {
          "id": "adsClientName",
          "type": "text",
          "label": "Client name",
          "placeholder": "Full name",
          "helperText": null,
          "required": true,
          "defaultValue": null
        },
        {
          "id": "adsClientEmail",
          "type": "email",
          "label": "Email",
          "placeholder": "name@business.com",
          "helperText": null,
          "required": true,
          "defaultValue": null
        },
        {
          "id": "adsBusinessName",
          "type": "text",
          "label": "Business name",
          "placeholder": "Business or trading name",
          "helperText": null,
          "required": true,
          "defaultValue": null
        },
        {
          "id": "campaignObjective",
          "type": "select",
          "label": "Campaign objective",
          "placeholder": null,
          "helperText": null,
          "required": true,
          "defaultValue": null,
          "options": [
            {
              "value": "leads",
              "label": "Lead generation"
            },
            {
              "value": "calls",
              "label": "Calls"
            },
            {
              "value": "sales",
              "label": "Online sales"
            },
            {
              "value": "awareness",
              "label": "Brand awareness"
            }
          ]
        },
        {
          "id": "kpiNotes",
          "type": "textarea",
          "label": "KPIs and targets",
          "placeholder": "For example: CPL target, lead volume, ROAS",
          "helperText": null,
          "required": true,
          "defaultValue": null
        },
        {
          "id": "targetLocations",
          "type": "textarea",
          "label": "Target locations",
          "placeholder": "Suburbs, cities, radius targeting",
          "helperText": null,
          "required": true,
          "defaultValue": null
        },
        {
          "id": "platforms",
          "type": "multiselect",
          "label": "Platforms",
          "placeholder": null,
          "helperText": null,
          "required": true,
          "defaultValue": null,
          "options": [
            {
              "value": "google",
              "label": "Google Ads"
            },
            {
              "value": "meta",
              "label": "Facebook and Instagram"
            },
            {
              "value": "linkedin",
              "label": "LinkedIn"
            },
            {
              "value": "tiktok",
              "label": "TikTok"
            }
          ]
        },
        {
          "id": "monthlyBudget",
          "type": "number",
          "label": "Monthly ad spend budget (AUD)",
          "placeholder": null,
          "helperText": "Approximate media spend only.",
          "required": true,
          "defaultValue": null,
          "validation": {
            "min": 0,
            "step": 50
          }
        },
        {
          "id": "creativeAssets",
          "type": "file",
          "label": "Upload creative assets (optional)",
          "placeholder": null,
          "helperText": "Logos, images, video, brand guide, previous ads.",
          "required": false,
          "defaultValue": null
        },
        {
          "id": "launchDate",
          "type": "date",
          "label": "Target start date",
          "placeholder": null,
          "helperText": null,
          "required": true,
          "defaultValue": null
        }
      ],
      "sections": [
        {
          "id": "adsClientDetails",
          "title": "Client and account details",
          "description": null,
          "fieldIds": [
            "adsClientName",
            "adsClientEmail",
            "adsBusinessName"
          ]
        },
        {
          "id": "adsObjectives",
          "title": "Objectives and KPIs",
          "description": null,
          "fieldIds": [
            "campaignObjective",
            "kpiNotes"
          ]
        },
        {
          "id": "adsTargeting",
          "title": "Targeting",
          "description": null,
          "fieldIds": [
            "targetLocations"
          ]
        },
        {
          "id": "adsPlatformsBudgets",
          "title": "Platforms and budgets",
          "description": null,
          "fieldIds": [
            "platforms",
            "monthlyBudget"
          ]
        },
        {
          "id": "adsCreativeTimeline",
          "title": "Creative and timelines",
          "description": null,
          "fieldIds": [
            "creativeAssets",
            "launchDate"
          ]
        }
      ]
    },
    {
      "id": "updateRequest",
      "name": "Update Request",
      "description": "Submit changes to an existing website, landing page, or digital asset managed by BPA Solutions.",
      "category": "Maintenance",
      "icon": "Edit3",
      "layout": {
        "columns": 1,
        "showSectionProgress": true,
        "showOverallProgress": false,
        "progressStyle": "steps"
      },
      "submission": {
        "successMessage": "Thank you. Your update request has been submitted successfully.",
        "failureMessage": "Submission failed. Please try again.",
        "redirectUrl": null,
        "storeSubmission": true
      },
      "fields": [
        {
          "id": "requestorName",
          "type": "text",
          "label": "Requestor name",
          "placeholder": "Full name",
          "helperText": null,
          "required": true,
          "defaultValue": null
        },
        {
          "id": "requestorEmail",
          "type": "email",
          "label": "Email",
          "placeholder": "name@business.com",
          "helperText": null,
          "required": true,
          "defaultValue": null
        },
        {
          "id": "siteUrl",
          "type": "url",
          "label": "Site or page URL",
          "placeholder": "https://",
          "helperText": "Paste the exact URL where the change is needed.",
          "required": true,
          "defaultValue": null
        },
        {
          "id": "changeType",
          "type": "select",
          "label": "Change type",
          "placeholder": null,
          "helperText": null,
          "required": true,
          "defaultValue": null,
          "options": [
            {
              "value": "content",
              "label": "Content change"
            },
            {
              "value": "design",
              "label": "Design tweak"
            },
            {
              "value": "bug",
              "label": "Bug fix"
            },
            {
              "value": "feature",
              "label": "New feature"
            }
          ]
        },
        {
          "id": "priority",
          "type": "select",
          "label": "Priority",
          "placeholder": null,
          "helperText": null,
          "required": true,
          "defaultValue": null,
          "options": [
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "normal",
              "label": "Normal"
            },
            {
              "value": "high",
              "label": "High"
            },
            {
              "value": "urgent",
              "label": "Urgent"
            }
          ]
        },
        {
          "id": "desiredCompletion",
          "type": "date",
          "label": "Desired completion date",
          "placeholder": null,
          "helperText": null,
          "required": false,
          "defaultValue": null
        },
        {
          "id": "changeDescription",
          "type": "textarea",
          "label": "Detailed description",
          "placeholder": "Describe exactly what should change and what the new content should be.",
          "helperText": "Include section names or screenshots if possible.",
          "required": true,
          "defaultValue": null
        },
        {
          "id": "attachments",
          "type": "file",
          "label": "Attachments (optional)",
          "placeholder": null,
          "helperText": "Upload screenshots or documents.",
          "required": false,
          "defaultValue": null
        }
      ],
      "sections": [
        {
          "id": "updateRequestor",
          "title": "Requestor details",
          "description": null,
          "fieldIds": [
            "requestorName",
            "requestorEmail"
          ]
        },
        {
          "id": "updateReference",
          "title": "Site reference",
          "description": null,
          "fieldIds": [
            "siteUrl"
          ]
        },
        {
          "id": "updateDetails",
          "title": "Change details",
          "description": null,
          "fieldIds": [
            "changeType",
            "priority",
            "desiredCompletion",
            "changeDescription",
            "attachments"
          ]
        }
      ]
    }
  ],
  "email": {
    "provider": {
      "name": "emailit",
      "apiUrl": "https://api.emailit.com/v1/emails",
      "apiKeyEnvVar": "VITE_EMAILIT_API_KEY",
      "fromAddress": "no-reply@bpasolutions.au",
      "replyToStrategy": {
        "useClientEmailIfAvailable": true,
        "fallbackAddress": "support@bpasolutions.au"
      }
    },
    "payloadTemplate": {
      "to": [
        "string"
      ],
      "cc": [
        "string"
      ],
      "bcc": [
        "string"
      ],
      "subject": "string",
      "text": "string",
      "html": "string",
      "tags": [
        "string"
      ],
      "metadata": {
        "submissionId": "string",
        "formId": "string"
      }
    },
    "routes": [
      {
        "id": "emailWebsiteIntake",
        "trigger": "onFormSubmit",
        "formId": "websiteClientIntake",
        "recipients": {
          "to": [
            {
              "type": "field",
              "value": "clientEmail"
            }
          ],
          "cc": [],
          "bcc": []
        },
        "templates": {
          "clientConfirmation": {
            "enabled": true,
            "subject": "We received your {{form.name}} submission ({{submissionId}})",
            "bodyText": "Hi {{submission.clientName}},\n\nThank you for submitting the {{form.name}}.\nSubmission ID: {{submissionId}}\nSubmitted: {{submittedAt}}\n\nWe will review your answers and contact you shortly.\n\n{{app.name}}",
            "bodyHtml": "<p>Hi <strong>{{submission.clientName}}</strong>,</p><p>Thank you for submitting the <strong>{{form.name}}</strong>.</p><p><strong>Submission ID:</strong> {{submissionId}}<br/><strong>Submitted:</strong> {{submittedAt}}</p><p>We will review your answers and contact you shortly.</p><p>{{app.name}}</p>"
          },
          "internalNotification": {
            "enabled": true,
            "subject": "New submission: {{form.name}} ({{submissionId}})",
            "bodyText": "New submission received.\nForm: {{form.name}} ({{form.id}})\nSubmission ID: {{submissionId}}\nClient: {{submission.clientName}}\nEmail: {{submission.clientEmail}}\nSubmitted: {{submittedAt}}",
            "bodyHtml": "<p><strong>New submission received</strong></p><ul><li><strong>Form:</strong> {{form.name}} ({{form.id}})</li><li><strong>Submission ID:</strong> {{submissionId}}</li><li><strong>Client:</strong> {{submission.clientName}}</li><li><strong>Email:</strong> {{submission.clientEmail}}</li><li><strong>Submitted:</strong> {{submittedAt}}</li></ul>"
          }
        },
        "conditions": {
          "sendClientConfirmation": true,
          "sendInternalNotification": true
        }
      },
      {
        "id": "emailAdsIntake",
        "trigger": "onFormSubmit",
        "formId": "adsIntake",
        "recipients": {
          "to": [
            {
              "type": "field",
              "value": "adsClientEmail"
            }
          ],
          "cc": [],
          "bcc": []
        },
        "templates": {
          "clientConfirmation": {
            "enabled": true,
            "subject": "We received your {{form.name}} submission ({{submissionId}})",
            "bodyText": "Thank you. We received your ads intake.\nSubmission ID: {{submissionId}}\nSubmitted: {{submittedAt}}\n\n{{app.name}}",
            "bodyHtml": "<p>Thank you. We received your ads intake.</p><p><strong>Submission ID:</strong> {{submissionId}}<br/><strong>Submitted:</strong> {{submittedAt}}</p><p>{{app.name}}</p>"
          },
          "internalNotification": {
            "enabled": true,
            "subject": "New submission: {{form.name}} ({{submissionId}})",
            "bodyText": "New ads intake received.\nSubmission ID: {{submissionId}}\nClient: {{submission.adsClientName}}\nEmail: {{submission.adsClientEmail}}\nSubmitted: {{submittedAt}}",
            "bodyHtml": "<p><strong>New ads intake received</strong></p><ul><li><strong>Submission ID:</strong> {{submissionId}}</li><li><strong>Client:</strong> {{submission.adsClientName}}</li><li><strong>Email:</strong> {{submission.adsClientEmail}}</li><li><strong>Submitted:</strong> {{submittedAt}}</li></ul>"
          }
        },
        "conditions": {
          "sendClientConfirmation": true,
          "sendInternalNotification": true
        }
      },
      {
        "id": "emailUpdateRequest",
        "trigger": "onFormSubmit",
        "formId": "updateRequest",
        "recipients": {
          "to": [
            {
              "type": "field",
              "value": "requestorEmail"
            }
          ],
          "cc": [],
          "bcc": []
        },
        "templates": {
          "clientConfirmation": {
            "enabled": true,
            "subject": "We received your {{form.name}} submission ({{submissionId}})",
            "bodyText": "Thank you. We received your update request.\nSubmission ID: {{submissionId}}\nSubmitted: {{submittedAt}}\n\n{{app.name}}",
            "bodyHtml": "<p>Thank you. We received your update request.</p><p><strong>Submission ID:</strong> {{submissionId}}<br/><strong>Submitted:</strong> {{submittedAt}}</p><p>{{app.name}}</p>"
          },
          "internalNotification": {
            "enabled": true,
            "subject": "New submission: {{form.name}} ({{submissionId}})",
            "bodyText": "New update request received.\nSubmission ID: {{submissionId}}\nRequestor: {{submission.requestorName}}\nEmail: {{submission.requestorEmail}}\nPriority: {{submission.priority}}\nSubmitted: {{submittedAt}}",
            "bodyHtml": "<p><strong>New update request received</strong></p><ul><li><strong>Submission ID:</strong> {{submissionId}}</li><li><strong>Requestor:</strong> {{submission.requestorName}}</li><li><strong>Email:</strong> {{submission.requestorEmail}}</li><li><strong>Priority:</strong> {{submission.priority}}</li><li><strong>Submitted:</strong> {{submittedAt}}</li></ul>"
          }
        },
        "conditions": {
          "sendClientConfirmation": true,
          "sendInternalNotification": true
        }
      }
    ]
  },
  "research": {
    "context": {
      "projectName": "BPA Forms Hub",
      "owner": "BPA Solutions",
      "description": "Configuration that powers a multi form intake hub with theming, navigation, routing, and email workflows."
    },
    "history": [
      {
        "id": "hist-001",
        "timestamp": "2026-01-20T00:00:00+11:00",
        "author": "Merlin",
        "summary": "Initial consolidated configuration created.",
        "details": "Created an extensible schema with app, themes, navigation, site, forms, email, and research."
      },
      {
        "id": "hist-002",
        "timestamp": "2026-01-20T00:05:00+11:00",
        "author": "Merlin",
        "summary": "Added stub forms for Ads Intake and Update Request.",
        "details": "Introduced two additional forms to demonstrate extensibility and per form email routes."
      }
    ],
    "tags": [
      "client-onboarding",
      "multi-form",
      "email-workflows",
      "website-intake",
      "ads-intake",
      "update-request"
    ],
    "notes": [
      {
        "id": "note-001",
        "createdAt": "2026-01-20T00:10:00+11:00",
        "author": "Merlin",
        "title": "Schema intent and extension guidance",
        "body": "This configuration is designed to be extended with additional forms and routes. It supersedes an older schema (meta,site,forms,email_logic) by introducing app,themes,navigation,site,forms,email,and research while staying compatible in intent."
      }
    ]
  }
};